var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashSolid1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1898_1708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01786 0.380273L2.85714 0.6875H0.714286C0.319196 0.6875 0 0.994727 0 1.375C0 1.75527 0.319196 2.0625 0.714286 2.0625H9.28571C9.6808 2.0625 10 1.75527 10 1.375C10 0.994727 9.6808 0.6875 9.28571 0.6875H7.14286L6.98214 0.380273C6.86161 0.146094 6.61384 0 6.34375 0H3.65625C3.38616 0 3.13839 0.146094 3.01786 0.380273ZM9.28571 2.75H0.714286L1.1875 10.0332C1.22321 10.5768 1.69196 11 2.2567 11H7.7433C8.30804 11 8.77679 10.5768 8.8125 10.0332L9.28571 2.75Z",
    fill: "#1C191A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1898_1708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolid1);
export default __webpack_public_path__ + "static/media/trash-solid 1.86c71d22831408e844a4039226afcc5a.svg";
export { ForwardRef as ReactComponent };